import React from 'react';

class GridLineStyle extends React.Component<Props> {
    render() {
        return (
            <style jsx={"true"}>
                {`.GridLine {
                  ${'background-image:' + this.props.GridLines + ';'}
                }`}
            </style>
        );
    }
}

export default GridLineStyle;
